import { useEffect, useState } from "react";
import { useReveal } from "./Reveal";

export default function CountUp({ end = 0, suffix = "", duration = 1500 }) {
  const [ref, shown] = useReveal();
  const [val, setVal] = useState(0);

  useEffect(() => {
    if (!shown) return;
    let raf;
    let startTs = null;
    const target = Number(end) || 0;
    const step = (ts) => {
      if (startTs === null) startTs = ts;
      const p = Math.min((ts - startTs) / duration, 1);
      const eased = 1 - Math.pow(1 - p, 3);
      setVal(Math.round(eased * target));
      if (p < 1) raf = requestAnimationFrame(step);
    };
    raf = requestAnimationFrame(step);
    return () => cancelAnimationFrame(raf);
  }, [shown, end, duration]);

  return (
    <span ref={ref}>
      {val}
      {suffix}
    </span>
  );
}
